export const forwardTabbing = (e) => {
  return e.event.key === "Tab" && e.event.shiftKey === false;
};

export const backwardTabbing = (e) => {
  return e.event.key === "Tab" && e.event.shiftKey === true;
};

export const onEnter = (e) => {
  return e.event.key === "Enter"
}
